import axios from 'axios';
import Cookies from 'js-cookie';
import { LoginResult } from 'utils/PlayFabAccountAPI';

const SESSION_COOKIE_NAME = 'dusk-session-id';
let sessionCookie = getApiSession();

export let apiClient = createApiClient();

function mergeSessionHeader(headers: Record<string, unknown>, sessionCookie?: string) {
  return {
    ...headers,
    ...(sessionCookie && {
      'x-api-session-id': sessionCookie,
    }),
  };
}

function createApiClient() {
  return axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: mergeSessionHeader({}, sessionCookie),
  });
}

/**
 * After login we have to refresh the session cookie, otherwise you can't
 * use apiClient to further request backend API on the same page.
 *
 * It happens to work in the past because we switch to other pages after login,
 * and apiClient is created again on other pages.
 */
export function refreshSession() {
  sessionCookie = getApiSession();
  apiClient = createApiClient();
}

export function setLogin(value: LoginResult, expires: Date): void {
  const sessionOptions: Cookies.CookieAttributes = {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    expires,
    path: '/',
  };
  const stringValue = JSON.stringify(value);
  Cookies.set(SESSION_COOKIE_NAME, stringValue, sessionOptions);
}

export function removeLogin(): void {
  Cookies.remove(SESSION_COOKIE_NAME);
}

export function getLogin(): undefined | LoginResult {
  const result = Cookies.get(SESSION_COOKIE_NAME) as string | undefined;
  if (!result) {
    return;
  }

  try {
    return JSON.parse(result) as LoginResult;
  } catch (err) {
    // in case something goes wrong, we wanna make sure to remove
    // any invalid cookies
    Cookies.remove(SESSION_COOKIE_NAME);
  }
}

export function getApiSession(): string | undefined {
  const login = getLogin();
  if (!login) {
    return;
  }
  return login.sessionId;
}
